/* Scroll-snap carousel with prev/next buttons (embla replacement).
   Uses event delegation so carousels rendered after page load work too. */
(function () {
  function step(track) {
    var item = track.querySelector('[data-carousel-item]');
    return item ? item.getBoundingClientRect().width : track.clientWidth / 2;
  }
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-carousel-prev]');
    var next = e.target.closest('[data-carousel-next]');
    if (!prev && !next) return;
    var root = (prev || next).closest('[data-carousel]');
    var track = root && root.querySelector('[data-carousel-track]');
    if (!track) return;
    if (prev) {
      if (track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: -step(track) * 2, behavior: 'smooth' });
    } else {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(track) * 2, behavior: 'smooth' });
    }
  });
  window.LuminateCarouselInit = function () {}; // delegation covers late-rendered carousels
})();
